@if (capsLock) {
  <p class="warning-msg">Caps Lock is on</p>
}
